import React, { useState, useEffect } from 'react';
import adminApi from '../../services/adminApi';
import LoadingSpinner from '../shared/LoadingSpinner';
import '../../styles/MigrationLogs.css';

// Hjælpefunktion til at formatere dato
function formatDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Ukendt dato';
  return date.toLocaleString('da-DK');
}

function MigrationLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isRunningMigrations, setIsRunningMigrations] = useState(false);

  const fetchLogs = async () => {
    try {
      const data = await adminApi.getMigrationLogs();
      setLogs(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleRunMigrations = async () => {
    setIsRunningMigrations(true);
    setError(null);
    try {
      await adminApi.runMigrations();
      // Opdater logs efter kørsel
      await fetchLogs();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsRunningMigrations(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="migration-logs">
      <div className="migration-header">
        <h3>Database Migration Logs</h3>
        <button 
          className="button button-primary"
          onClick={handleRunMigrations}
          disabled={isRunningMigrations}
        >
          {isRunningMigrations ? 'Kører migrationer...' : 'Kør migrationer'}
        </button>
      </div>
      
      {error && (
        <div className="error-message">
          Fejl: {error}
        </div>
      )}

      <div className="logs-container">
        <div className="logs-list">
          {logs.map((log) => (
            <div
              key={log.id}
              className={`log-item ${selectedLog?.id === log.id ? 'selected' : ''} ${log.status === 'error' ? 'error' : ''}`}
              onClick={() => setSelectedLog(log)}
            >
              <div className="log-timestamp">
                {formatDate(log.timestamp)}
              </div>
              <div className="log-summary">
                <div className="log-name">{log.migration_name}</div>
                <div className="log-status">{log.status}</div>
                <div className="log-time">{log.execution_time_ms}ms</div>
              </div>
            </div>
          ))}
        </div>
        <div className="log-details">
          {selectedLog ? (
            <div className="log-content">
              <div className="log-header">
                <h4>{selectedLog.migration_name}</h4>
                <div className="log-meta">
                  <span className={`status ${selectedLog.status}`}>{selectedLog.status}</span>
                  <span className="time">{selectedLog.execution_time_ms}ms</span>
                </div>
              </div>
              {selectedLog.content.map((entry, index) => (
                <div key={index} className="log-entry">
                  <span className="log-time">
                    {formatDate(entry.timestamp)}
                  </span>
                  <span className="log-message">{entry.message}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-log-selected">
              Vælg en log for at se detaljer
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MigrationLogs; 